var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyMatchesActivityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 11,
    fill: "#FFEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6779_1490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4258 17.3547H33.157C31.3695 17.3547 29.9258 18.8422 29.9258 20.6839V43.3506C29.9258 45.1922 31.3695 46.6797 33.157 46.6797H46.4258C48.2133 46.6797 49.657 45.1922 49.657 43.3506V20.6839C49.657 18.8422 48.2133 17.3547 46.4258 17.3547ZM39.757 37.7547C39.757 37.7547 33.8445 33.2922 33.8445 30.0339C33.8445 28.1922 35.2883 26.7047 37.0758 26.7047C38.1758 26.7047 39.207 27.2714 39.757 28.1922C40.307 27.2714 41.3383 26.7047 42.4383 26.7047C44.2258 26.7047 45.6695 28.1922 45.6695 30.0339C45.7383 33.1506 39.757 37.7547 39.757 37.7547Z",
    fill: "#FF7705",
    fillOpacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1567 48.0963C30.6129 48.0963 28.5504 45.9713 28.5504 43.3505V38.7463C26.5567 37.6838 24.1504 35.9838 23.6692 34.213C23.1879 32.4421 24.2192 30.6005 25.9379 30.1046C26.9004 29.8213 27.7942 30.0338 28.5504 30.5296V20.6838C28.5504 20.3296 28.6192 20.0463 28.6192 19.6921L19.7504 22.1713C18.0317 22.6671 17.0004 24.5088 17.4817 26.2796L23.1879 48.1671C23.6692 49.938 25.4567 51.0005 27.1754 50.5046L35.8379 48.0963H33.1567Z",
    fill: "#E60000",
    fillOpacity: 0.81
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6779_1490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 34,
    fill: "white",
    transform: "translate(17 17.0005)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMatchesActivityIcon);
export default __webpack_public_path__ + "static/media/MyMatches-Activity-icon.be57b362d0063b3031ab5256831cbcee.svg";
export { ForwardRef as ReactComponent };